import React,{useState,useEffect,useRef} from "react";
import CrossIcon from './../../../../images/crossicon.png'
import axios from "axios"; 
import mfapopupimg from './../../../../images/mfapopupimg.png'
import mfasuccess from './../../../../images/mfasuccess.png'
import mfadisabled from './../../../../images/mfadisabled.png'
import { Trans, useTranslation} from 'react-i18next'
import Cookies from 'universal-cookie';
import { useJwt, decodeToken } from "react-jwt";
import ReactModal from 'react-modal';
import GreenTick from './../../../../images/greentick.png'
import WarningIcon from './../../../../images/warningicon.png'


function SecuritySettings({toogleOption,toogleTaskbar}){
 const [mfaPopup,setMfaPopup] = useState(false)
 const [accessCodePopup,setAccessCodePopup] = useState(false)
 const [recoveryKeyPopup,setRecoveryKeyPopup] = useState(false)
 const [mfaSuccessPopup,setMfaSuccessPopup] = useState(false)
 const [verifyIdPopup,setVerifyIdPopup] = useState(false)
 const [verifyCodePopup,setVerifyCodePopup] = useState(false)
 const [confirmDisablePopup,setConfirmDisablePopup] = useState(false)
 const [mfaDisabledPopup,setMfaDisabledPopup] = useState(false)
 const [recoveryInputPopup,setRecoveryInputPopup] = useState(false)
 const [accessCodeError,setAccessCodeError] = useState(false);
 const [timeLeft, setTimeLeft] = useState(null);
 const [buttonClick, setButtonClick] = useState(0);
 const [recoveryKey,setRecoveryKey] = useState('')
 const {t, i18n } = useTranslation();
 const cookies = new Cookies(null ,{ path: '/' });
 const [code, setCode] = useState('');
 const [email,setEmail] = useState(decodeToken(cookies.get('token')).email)
 const [mfaStatus,setMfaStatus] = useState(decodeToken(cookies.get('token')).mfa)
 const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
];


 {/** Functions  */}


// Handle input
function handleInput(e, index) {
    const input = e.target;
    const previousInput = inputRefs[index - 1];
    const nextInput = inputRefs[index + 1];

    // Update code state with single digit
    const newCode = [...code];
    // Convert lowercase letters to uppercase
    if (/^[a-z]+$/.test(input.value)) {
        const uc = input.value.toUpperCase();
        newCode[index] = uc;
        inputRefs[index].current.value = uc;
    } else {
        newCode[index] = input.value;
    }
    setCode(newCode.join(''));

    input.select();

    if (input.value === '') {
        // If the value is deleted, select previous input, if exists
        if (previousInput) {
            previousInput.current.focus();
        }
    } else if (nextInput) {
        // Select next input on entry, if exists
        nextInput.current.select();
    }
}

const resetCode = () => {
    inputRefs.forEach(ref => {
        ref.current.value = '';
    });
    inputRefs[0].current.focus();
    setCode('');
}


 // Select the contents on focus
 function handleFocus(e) {
    e.target.select();
}

// Handle backspace key
function handleKeyDown(e, index) {
    const input = e.target;
    const previousInput = inputRefs[index - 1];
    const nextInput = inputRefs[index + 1];

    if ((e.keyCode === 8 || e.keyCode === 46) && input.value === '') {
        e.preventDefault();
        setCode((prevCode) => prevCode.slice(0, index) + prevCode.slice(index + 1));
        if (previousInput) {
            previousInput.current.focus();
        }
    }
}

// Capture pasted characters
const handlePaste = (e) => {
    const pastedCode = e.clipboardData.getData('text');
    if (pastedCode.length === 6) {
        setCode(pastedCode);
        inputRefs.forEach((inputRef, index) => {
            inputRef.current.value = pastedCode.charAt(index);
        });
    }
};




{/** Route Calls */}


const handleRecovery = () =>{
    axios({
        method:'post',
        url:"https://n3rve.fly.dev/auth/mfa/recovery",
        data:{
          recoveryCode:recoveryKey,
          email:email,
          purpose:"toggle"
        }
    }).then(res=>{
      console.log(res)
      const current = new Date();
      const nextYear = new Date();
      nextYear.setFullYear(current.getFullYear() + 1)
      if(cookies.get("staysignedin"))
      {
         cookies.set('token', res.data.token,{
         path: '/',
         expires: nextYear
       });
      }else{
       cookies.set('token', res.data.token);
         }
        setRecoveryInputPopup(false);
        setConfirmDisablePopup(true);
    }).catch((e)=>{
      console.log(e)
    })
}


const handleConfirmMfa = (code) =>{
    console.log(code)
    console.log(email)
    const current = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(current.getFullYear() + 1)
    axios({
        method:'post',
        url:"https://n3rve.fly.dev/auth/mfa/toggle/confirm",
        headers:{
            Authorization: "Bearer ".concat(cookies.get("token"))
        },
        data: {
            code: code.toString(), 
            email: email.toString()
           }
    }).then(res=>{
      console.log(res)
      setAccessCodeError(false)
      if(cookies.get("staysignedin"))
     {
        cookies.set('token', res.data.token,{
        path: '/',
        expires: nextYear
      });
     }else{
      cookies.set('token', res.data.token);
        }
      if(accessCodePopup){
      setRecoveryKey(res.data.recoveryCode)
      setAccessCodePopup(false)
      setRecoveryKeyPopup(true)
      }
     
    }).catch((e)=>{
        console.log(e)
        setAccessCodeError(true)
    })
}


const handleToggleMfa = () =>{
    axios({
        method:'post',
        url:"https://n3rve.fly.dev/auth/mfa/toggle",
        headers:{
            Authorization: "Bearer ".concat(cookies.get("token"))
        }
    }).then(res=>{
      console.log(res)
    })
}



const HandlePassReset = () => {
    axios({
      method:'post',
      url:"https://n3rve.fly.dev/auth/forgot",
      data:{
        email:email,
        domain:'https://n3rve-b4b3b625d069.herokuapp.com'
      }
  }).then(res=>{
    console.log(res)
  }).catch((e)=>{
    console.log(e)
  })

}




{/** Use Effect Hooks */}

useEffect(() => {
    // exit early when we reach 0
    if (!timeLeft) return;

    if(timeLeft===1){
      console.log("TIME LEFT IS 1");
      setButtonClick(0)
    }

    if(timeLeft===0){
       console.log("TIME LEFT IS 0");
    }

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
  // clear interval on re-render to avoid memory leaks
  return () => clearInterval(intervalId);
}, [timeLeft]);

useEffect(()=>{
    setEmail(decodeToken(cookies.get('token')).email)
    toogleOption(3)
},[])

useEffect(()=>{
    if(code.length===6){
        if(accessCodePopup){
            handleConfirmMfa(code)
        }
        if(verifyCodePopup){
            setVerifyCodePopup(false)
            setConfirmDisablePopup(true)
        }
        
    } 
},[code])


 return (
    <div style={{display:'flex',flexDirection:'column',paddingBottom:'2.5em',borderRadius:'8px',marginLeft:'2.5em',marginTop:'1.5em',width:'93.28%',backgroundImage:' linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
                            
    {/* Security Settings Page */} 

    <div className="MembershipTxt" stlye={{marginBottom:'1.5em'}}> {t('Resetyourpassword')}</div>
   
    
    <div className="PasswordReserBtn" onClick={()=>HandlePassReset()}>
        Send Password Reset Email
    </div>

    <div className="MembershipTxt" stlye={{marginBottom:'1.5em'}}>SETUP MFA</div>

    {
        !mfaStatus &&
        <div className="SecurityInfo">
        Setup MFA (Multi-Factor Authentication) to enhance your security with multiple layers of protection.
        </div>
    }
   

    {
        !mfaStatus &&
        <div className="PasswordReserBtn" style={{width:'8em',marginBottom:'0em'}} onClick={()=>setMfaPopup(true)}>
            Enable MFA
        </div>
    }

    {
        mfaStatus &&
        <div className="SecurityInfo">
        Activate MFA (Multi-Factor Authentication) to enhance your security with multiple layers of protection.
        </div>
    }

    {
        mfaStatus &&
        <div className="PasswordReserBtn" style={{width:'8em',marginBottom:'0em'}} onClick={()=>setVerifyIdPopup(true)}>
            Disable MFA
        </div>
    }



     {/* Verify MFA Popups */}


     <ReactModal
    overlayClassName="Overlay"
    isOpen={mfaPopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'30em',
        height:'34.06em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
            <div className="popupheaderinfo">Setup Multi-Factor Authentication</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setMfaPopup(false)}/>
           

        

            <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>By enabling Multi-Factor Authentication (MFA), you’re adding a powerful security layer to your account.</span>
            <img src={mfapopupimg} style={{borderRadius:'8px',width:'26.75em',height:'15.81em',marginBottom:'2em'}}/>
            <div className="IUnderstandBtn" style={{cursor:'pointer'}} onClick={()=>{handleToggleMfa();setMfaPopup(false);setAccessCodePopup(true)}}>Continue</div>
    </ReactModal>

    <ReactModal
    overlayClassName="Overlay"
    isOpen={accessCodePopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'30em',
        height:'34.06em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
            <div className="popupheaderinfo">Enter the Access Code</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setAccessCodePopup(false)}/>
           

        

            <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>We've sent a 6-digit access code to your email {email.charAt(0).concat("******").concat('@').concat(email.split('@')[1])} Enter the code below to verify. This code will expire in 10 minutes.</span>
           
           
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'2em'}}>
                {[0, 1, 2, 3, 4, 5].map((index) => (
                    <input
                        className={!accessCodeError ?  'AccessCodeInput': 'AccessCodeInputErr'}
                        key={index}
                        type="text"
                        maxLength={1}
                        onChange={(e) => handleInput(e, index)}
                        ref={inputRefs[index]}
                        autoFocus={index === 0}
                        onFocus={handleFocus}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={handlePaste}
                    />
                ))}
            </div>
           

            {
                accessCodeError &&
                <div className="AccessCodeError">Invalid Code. Please re-enter or request a new one.</div>
            }

            {
                buttonClick===0 &&
                <span className="NoPasswordTxt">
                    Didn't receive the code?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span className="ResendCode" onClick={()=>{handleToggleMfa();setTimeLeft(30);setButtonClick(1)}}>Resend code</span>
                </span>
            }

            {
                buttonClick===1 &&
                <div>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={GreenTick}/>
                        <div className="NewCodeMsg">A new code was sent</div>
                    </div>
                    <span className="NoPasswordTxt">
                        You can resend in {timeLeft} sec... 
                    </span>
                </div>
            }
           
           {
              buttonClick===0 &&
              <div className="GoBackBtn" style={{cursor:'pointer',marginTop:'10em'}} onClick={()=>{setAccessCodePopup(false);setMfaPopup(true)}}>Go Back</div>
           }

            {
              buttonClick===1 &&
              <div className="GoBackBtn" style={{cursor:'pointer',marginTop:'10em'}} >Go Back</div>
           }
           
    </ReactModal>


    <ReactModal
    overlayClassName="Overlay"
    isOpen={recoveryKeyPopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'30em',
        height:'26.06em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
            <div className="popupheaderinfo" style={{width:'80%'}}>Secure your "Recovery Key"</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setRecoveryKeyPopup(false);setCode('');setRecoveryKey('')}}/>
           

        

            <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>Almost there! Please note down the 12-digit recovery key shown below.  It's crucial for regaining account access if you ever lose access to your one-time passcode. </span>
           
           {
            recoveryKey.length!==0 &&
            <div className="RecoveryKeyBox">
               {recoveryKey.substring(0,3).concat(" ").concat(recoveryKey.substring(3,6)).concat(" ").concat(recoveryKey.substring(6,9).concat(" ").concat(recoveryKey.substring(9,12)))}
            </div>
           }
            

            <div style={{display:'flex',flexDirection:'row',marginTop:'2em',alignItems:'center',width:'90%'}}>
                <img src={WarningIcon} style={{width:'1.30em',height:'1.13em',marginRight:'0.75em'}}/>
                <div className="RecoveryKeyWarning"> 
                Store it securely, ensuring only you can access it, to maintain your account's safety and accessibility.
                </div>
            </div>
            
            <div className="IUnderstandBtn" style={{cursor:'pointer',marginTop:'2em',width:'90%'}} onClick={()=>{setRecoveryKeyPopup(false);setMfaSuccessPopup(true);setCode('');setRecoveryKey('')}}>Continue</div>
            
    </ReactModal>

    <ReactModal
    overlayClassName="Overlay"
    isOpen={mfaSuccessPopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'30em',
        height:'36.875em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
            <div className="popupheaderinfo" style={{width:'80%'}}>You're all set</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setMfaSuccessPopup(false)}/>
           

            <img src={mfasuccess} style={{borderRadius:'12px',width:'27em',height:'11.18em',marginTop:'2em',marginLeft:'1.2em'}}/>

            <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em',fontWeight:'regular'}}>Your account is now secured with email MFA verification. Each time you log in, you'll receive a verification code to ensure it's really you.</span>
           
            <div className="DisableMfaMessage">
                You can disable multi-factor authentication at any time in your account settings.
            </div>
          

          
            
            <div className="IUnderstandBtn" style={{cursor:'pointer',marginTop:'2em',width:'90%',height:'3em'}} onClick={()=>{setMfaSuccessPopup(false);setMfaStatus(true)}}>Done</div>
            <div className="GoBackBtn" style={{cursor:'pointer',marginTop:'1em'}} onClick={()=>{setMfaSuccessPopup(false);setRecoveryKeyPopup(true)}}>Go Back</div>
    </ReactModal>


    {/* Disable MFA Popups */}
    <ReactModal
    overlayClassName="Overlay"
    isOpen={verifyIdPopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'30em',
        height:'34.06em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
            <div className="popupheaderinfo" style={{width:'80%'}}>Verify Your Identity</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setVerifyIdPopup(false)}/>
           

        

            <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>For your security, we'll send an access code to your email:&nbsp;&nbsp;&nbsp;<span style={{fontWeight:'700'}}>{email.charAt(0).concat("******").concat('@').concat(email.split('@')[1])}</span></span>
            <span className="SettingPopupH3" style={{width:'90%',marginTop:'0.5em',marginLeft:'1em'}}>Please click "Send Code" to receive your verification code.</span>
           
            

            <span className="NoPasswordTxt" style={{marginTop:'14em',marginBottom:'1em'}}>
            Cannot access code?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span className="ResendCode" onClick={()=>{setVerifyIdPopup(false);setRecoveryInputPopup(true)}}>Use Recovery Key</span>
            </span>
            
            <div className="IUnderstandBtn" style={{cursor:'pointer',marginTop:'0em',width:'90%'}} onClick={()=>{handleToggleMfa();setVerifyIdPopup(false);setVerifyCodePopup(true)}}>Send Code</div>
            
    </ReactModal>

    <ReactModal
    overlayClassName="Overlay"
    isOpen={verifyCodePopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'30em',
        height:'34.06em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
        <div className="popupheaderinfo">Enter Verification Code</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setVerifyCodePopup(false)}/>
           

        

            <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>We've sent a 6-digit access code to your email t******@gmail.com. Enter the code below to verify. This code will expire in 10 minutes.</span>
            
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'2em'}}>
                {[0, 1, 2, 3, 4, 5].map((index) => (
                    <input
                        className={!accessCodeError ?  'AccessCodeInput': 'AccessCodeInputErr'}
                        key={index}
                        type="text"
                        maxLength={1}
                        onChange={(e) => handleInput(e, index)}
                        ref={inputRefs[index]}
                        autoFocus={index === 0}
                        onFocus={handleFocus}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={handlePaste}
                    />
                ))}
            </div>

            {
                accessCodeError &&
                <div className="AccessCodeError">Invalid Code. Please re-enter or request a new one.</div>
            }
          
              
            {
                buttonClick===0 &&
                <span className="NoPasswordTxt">
                    Didn't receive the code?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span className="ResendCode" onClick={()=>{handleToggleMfa();setTimeLeft(30);setButtonClick(1)}}>Resend code</span>
                </span>
            }

            {
                buttonClick===1 &&
                <div>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={GreenTick}/>
                        <div className="NewCodeMsg">A new code was sent</div>
                    </div>
                    <span className="NoPasswordTxt">
                        You can resend in {timeLeft} sec... 
                    </span>
                </div>
            }
            {
                buttonClick===0 &&
                <div className="GoBackBtn" style={{cursor:'pointer',marginTop:'10em'}} onClick={()=>{setVerifyCodePopup(false);setVerifyIdPopup(true)}}>Go Back</div>
            }

            {
                buttonClick===1 &&
                <div className="GoBackBtn" style={{cursor:'pointer',marginTop:'10em'}} >Go Back</div>
            }
            
    </ReactModal>


    <ReactModal
    overlayClassName="Overlay"
    isOpen={confirmDisablePopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'32em',
        height:'34.06em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
        <div className="popupheaderinfo">Disable MFA?</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setConfirmDisablePopup(false);setCode('')}}/>
           

        

            <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>Are you sure you wish to disable Multi-Factor Authentication (MFA)? This action will reduce your account's security.</span>
           
           
           
            <div style={{display:'flex',flexDirection:'row',marginTop:'20em'}}>
                <div className="GoBackBtn" style={{paddingTop:'0.55em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setConfirmDisablePopup(false);setCode('')}}>
                    Cancel
                </div>

                <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{handleConfirmMfa(code);setConfirmDisablePopup(false);setMfaDisabledPopup(true)}}>
                    Disable MFA
                </div>
            </div>
    </ReactModal>


    <ReactModal
    overlayClassName="Overlay"
    isOpen={mfaDisabledPopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'30em',
        height:'30.81em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
        <div className="popupheaderinfo">MFA Disabled</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setMfaDisabledPopup(false);setMfaStatus(false)}}/>
           
            <img src={mfadisabled} style={{borderRadius:'12px',width:'27em',height:'11.18em',marginTop:'2em',marginLeft:'1.2em'}}/>

        

            <span className="SettingPopupH3" style={{width:'90%',marginTop:'2em',marginLeft:'2.5em'}}>MFA is now disabled. Your account is protected by your password only. </span>
           
           
           
           

                <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer',width:'85%',marginTop:'5.5em'}} onClick={()=>{setMfaDisabledPopup(false);setMfaStatus(false)}}>
                   Done
                </div>
            
    </ReactModal>


    <ReactModal
    overlayClassName="Overlay"
    isOpen={recoveryInputPopup}
    contentLabel="Example Modal"
    style={{
        content:{
        width:'30em',
        height:'33.75em',
        margin:'auto',
        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        borderRadius:'8px',
        border:'0.5px solid rgba(255,255,255,25%)'
        }
    }}
    >
        
        <div className="popupheaderinfo">Enter Your Recovery Key</div>
           

        <span className="SettingPopupH3" style={{width:'90%',marginTop:'2em',marginLeft:'1.1em'}}>Can't access your MFA code? Enter the 12-digit recovery key provided to you during the MFA set up process.</span>
           
        <div className="MfaInputHeader">
            Recovery Key (12-digitl)
        </div>

        <div style={{display:'flex',height:'3em',width:'82%',marginTop:'1em',flexDirection:'row',alignItems:'center',paddingLeft:'0.75em',paddingRight:'0.75em',justifyContent:'space-between',borderRadius:'4px',border:'1px solid rgba(255,255,255,40%)'}}>
            <input
            value={recoveryKey}
            onChange={e => setRecoveryKey(e.target.value)} 
            className='RecoveryKeyInput'
            type='text'
            placeholder="000 000 000 000"
            />
            {
                recoveryKey.length===12 &&
                <img src={GreenTick}/>
            }
            
        </div>
           
           
           

        <div style={{display:'flex',flexDirection:'row',marginTop:'12em'}}>
                <div className="GoBackBtn" style={{paddingTop:'0.55em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setRecoveryInputPopup(false);setVerifyIdPopup(true)}}>
                    Back
                </div>
              
                {
                    recoveryKey.length===12 &&
                    <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{handleRecovery();}}>
                    Continue
                </div>
                }

                {
                    recoveryKey.length!==12 &&
                    <div className="IUnderstandBtn" style={{height:'3em',backgroundColor:'#821D41',color:'#8D9297'}} >
                    Continue
                </div>
                }
               
        </div>
            
    </ReactModal>
    


</div>
 )
}

export default SecuritySettings;